var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('dash',{attrs:{"icon":"fa fa-file-text-o","titulo":"SERVIÇOS"},nativeOn:{"click":function($event){return _vm.toComprometimentos()}}}),_c('dash',{attrs:{"icon":"fa fa-file-text-o","titulo":"BOLETINS DE MEDIÇÃO"},nativeOn:{"click":function($event){return _vm.toBoletinsMedicao()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }